export default __webpack_public_path__ + "static/media/ic_check.010e686c.svg";